/**
 * There will be one reducer file per page / common component
 */
import {
    GET_ORDERS_SUCCESS,
    GET_ORDERS_FAILURE,
    GET_ORDERS,
    GET_CARD_DATA,
    GET_CARD_DATA_SUCCESS,
    GET_CARD_DATA_FAILURE,
    GET_VIEW_DATA,
    SET_VIEW_DATA_EMPTY,
    GET_VIEW_DATA_SUCCESS,
    GET_VIEW_DATA_FAILURE,
    GET_SEARCH_CARD_DATA,
    GET_SEARCH_CARD_DATA_SUCCESS,
    GET_SEARCH_CARD_DATA_FAILURE,
    GET_CARD_PREVIEW_DETAILS,
    GET_CARD_PREVIEW_DETAILS_SUCCESS,
    GET_CARD_PREVIEW_DETAILS_FAILURE,
    CLOSE_PREVIEW_DETAILS_MODAL,
    GET_LIST_DATA,
    GET_LIST_DATA_SUCCESS,
    GET_LIST_DATA_FAILURE,
} from '../actions';

const initialState = {
    viewData: {
        surgeryDates: [],
        error: '',
    },
    listData: {
        orders: [],
        error: '',
    },
    cardData: {
        orders: [],
        error: '',
    },
    searchCardData: {
        orders: [],
        error: '',
    },
    loading: false,
    viewDataLoading: false,
    cardDataLoading: false,
    listDataLoading: false,
    additionalViewDataLoading: false,
    searchCardDataLoading: false,
    orderPreview: false,
    cardPreviewDetails: [],
    cardPreviewError: '',
    tabListDetails: [],
};

const getUniqueDates = (dateArray) => {
    let sortedUniqueSurgeryDates = dateArray
        .map((date) => {
            return new Date(date).setHours(0, 0, 0, 0);
        })
        .filter((date, index, array) => {
            return array.indexOf(date) === index;
        })
        .map((time) => {
            return new Date(time);
        });
    return sortedUniqueSurgeryDates;
};

const applyData = (data, state) => {
    if (data.resourceType === 'VIEW_DATA') {
        let currentSurgeryDates = state.viewData.surgeryDates || [];
        let incomingSurgeryDates = (data.orderData || []).map(
            (order) => new Date(order.surgeryStartDate)
        );
        let newSurgeryDates = incomingSurgeryDates.concat(currentSurgeryDates);
        let sortedSurgeryDates = newSurgeryDates.sort((a, b) =>
            b < a ? 1 : -1
        );

        return {
            ...state,
            viewData: {
                surgeryDates: getUniqueDates(sortedSurgeryDates),
            },
        };
    } else if (data.resourceType === 'LIST_DATA') {
        return { ...state, listData: data };
    } else if (data.resourceType === 'CARD_DATA') {
        return { ...state, cardData: data };
    } else if (data.resourceType === 'SEARCH_CARD_DATA') {
        return { ...state, searchCardData: data };
    }
};

const applyError = (data, state) => {
    if (data.resourceType === 'VIEW_DATA') {
        return {
            ...state,
            viewData: { ...state.viewData, error: data.templateError },
        };
    } else if (data.resourceType === 'LIST_DATA') {
        return {
            ...state,
            listData: { ...state.listData, error: data.templateError },
        };
    } else if (data.resourceType === 'CARD_DATA') {
        return {
            ...state,
            cardData: { ...state.cardData, error: data.templateError },
        };
    }
};
const OrdersReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ORDERS:
            return {
                ...state,
                loading: true,
            };
        case GET_ORDERS_SUCCESS:
            return {
                ...applyData(action.data, state),
                loading: false,
            };
        case GET_ORDERS_FAILURE:
            return {
                ...applyError(action, state),
                loading: false,
            };
        case GET_VIEW_DATA:
            return {
                ...state,
                viewDataLoading: true,
            };
        case GET_VIEW_DATA_SUCCESS:
            return {
                ...applyData(action.data, state),
                viewDataLoading: false,
            };
        case GET_VIEW_DATA_FAILURE:
            return {
                ...applyError(action, state),
                viewDataLoading: false,
            };
        case SET_VIEW_DATA_EMPTY:
            return {
                ...state,
                viewData: {
                    surgeryDates: [],
                },
            };

        case GET_CARD_DATA:
            return {
                ...state,
                cardDataLoading: true,
            };
        case GET_CARD_DATA_SUCCESS:
            return {
                ...applyData(action.data, state),
                cardDataLoading: false,
            };
        case GET_CARD_DATA_FAILURE:
            return {
                ...applyError(action, state),
                cardDataLoading: false,
            };
        case GET_SEARCH_CARD_DATA:
            return {
                ...state,
                searchCardDataLoading: true,
            };
        case GET_SEARCH_CARD_DATA_SUCCESS:
            return {
                ...applyData(action.data, state),
                searchCardDataLoading: false,
            };
        case GET_SEARCH_CARD_DATA_FAILURE:
            return {
                ...applyError(action, state),
                searchCardDataLoading: false,
            };

        case GET_CARD_PREVIEW_DETAILS:
            return {
                ...state,
            };
        case GET_CARD_PREVIEW_DETAILS_SUCCESS:
            return {
                ...state,
                cardPreviewDetails: action.data.result,
                cardPreviewError: '',
            };
        case GET_CARD_PREVIEW_DETAILS_FAILURE:
            return {
                ...state,
                cardPreviewDetails: [],
                cardPreviewError: action.cardPreviewError,
            };
        case CLOSE_PREVIEW_DETAILS_MODAL:
            return {
                ...state,
                cardPreviewDetails: [],
                orderPreview: action.payload,
                cardPreviewError: '',
            };
        case GET_LIST_DATA:
            return {
                ...state,
                listDataLoading: true,
            };
        case GET_LIST_DATA_SUCCESS:
            return {
                ...applyData(action.data, state),
                listDataLoading: false,
            };
        case GET_LIST_DATA_FAILURE:
            return {
                ...applyError(action, state),
                listDataLoading: false,
            };
        default: {
            return { ...state };
        }
    }
};
export default OrdersReducer;
